import { SizeVO } from 'library/ts/model/vo/SizeVO';
import * as NumberModule from 'library/ts/utilities/modules/Number';

/**
 * @description Dynamic value calculator
 * @param baseContainerSize {SizeVO|ClientRect|DOMRect} base container size
 * @param latestContainerSize {SizeVO|ClientRect|DOMRect} latest container size
 * @param baseValue {Number} base value
 * @param minValue {Number} minimum value
 * @param maxValue {Number} maximum value
 * @return {Number}
 */
export const dynamicValue = ( baseContainerSize: SizeVO | ClientRect | DOMRect, latestContainerSize: SizeVO | ClientRect | DOMRect, baseValue: number, minValue: number, maxValue: number ): number => {
	const baseArea = baseContainerSize.width * baseContainerSize.height; // base container area size
	const realArea = latestContainerSize.width * latestContainerSize.height; // real player area size
	const percent = realArea / baseArea; // percent of real player size against the base
	let newValue = ( baseValue * percent ); // calculate new value
	newValue = NumberModule.clamp( newValue, minValue, maxValue ); // clamp value between minimum allowed and base
	return newValue; // return updated value
};

/**
 * @description Helper function: calculates proportional resize
 * @param currentWidth {Number}
 * @param currentHeight {Number}
 * @param desiredWidth {Number}
 * @param desiredHeight {Number}
 * @return {SizeVO}
 * @example
 * ```typescript
 * {
 *      width:newWidth,
 *      height:newHeight
 * }
 * ```
 */
export const proportionalResize = ( currentWidth: number, currentHeight: number, desiredWidth: number, desiredHeight: number ): SizeVO => {
	const output: SizeVO = new SizeVO();
	output.width = 0;
	output.height = 0;

	const targetRatio: number = desiredWidth / desiredHeight;
	const currentRatio: number = currentWidth / currentHeight;

	// We'll scale height
	if ( currentRatio > targetRatio ) {
		output.width = desiredWidth;
		output.height = currentHeight * ( output.width / currentWidth );
	} else {
		// We'll scale width
		output.height = desiredHeight;
		output.width = currentWidth * ( output.height / currentHeight );
	}

	if ( currentRatio === 1 ) {
		if ( desiredWidth > desiredHeight || desiredWidth < desiredHeight ) {
			output.height = currentHeight * ( output.width / currentWidth );
			output.width = currentWidth * ( output.height / currentHeight );
		}

		if ( desiredWidth === desiredHeight ) {
			output.height = desiredHeight;
			output.width = desiredWidth;
		}
	}

	return output;
};